<script setup>
import { computed, getCurrentInstance } from 'vue';
import { usePage } from '@inertiajs/vue3';
import BaseDashboardBreadcrumb from '@/layout/base/BaseDashboardBreadcrumb.vue';
import { pageTitles } from '@/layout/main/menu.js';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;
const page = usePage();

// Get current route name and generate breadcrumb items specific to client
const breadcrumbItems = computed(() => {
    const routeName = route().current();
    const breadcrumbs = [];
    
    const filters = page.props?.filters?.filter || {};
    const cameFromDashboard = sessionStorage.getItem('previousRoute') === 'client.dashboard';
    
    const addContextualBreadcrumb = (pageKey, parentPageKey = null) => {
        if (cameFromDashboard) {
            breadcrumbs.push($t(pageTitles('dashboard')));
        } else if (parentPageKey) {
            breadcrumbs.push($t(pageTitles(parentPageKey)));
        }
        breadcrumbs.push($t(pageTitles(pageKey)));
    };

    if (routeName === 'client.dashboard') {
        breadcrumbs.push($t(pageTitles('dashboard')));
        sessionStorage.setItem('previousRoute', 'client.dashboard');
    } else if (routeName?.startsWith('client.sites')) {
        if (filters.favorites) {
            addContextualBreadcrumb('myFavorites', 'linkBuilding');
        } else if (filters.interests) {
            addContextualBreadcrumb('myInterests', 'linkBuilding');
        } else if (filters.project && page.props?.project) {
            breadcrumbs.push($t(pageTitles('allProjects')));
            breadcrumbs.push(page.props.project.name);
        } else {
            addContextualBreadcrumb('browseSites', 'linkBuilding');
        }
        
        sessionStorage.setItem('previousRoute', routeName);
        if (routeName === 'client.sites.show') {
            breadcrumbs.push($t('Site Details'));
        }
    } else if (routeName?.startsWith('client.orders')) {
        addContextualBreadcrumb('myOrders', 'linkBuilding');
        sessionStorage.setItem('previousRoute', routeName);
        if (routeName === 'client.orders.show') {
            breadcrumbs.push($t('Order Details'));
        }
    } else if (routeName?.startsWith('client.projects')) {
        if (routeName === 'client.projects.create') {
            addContextualBreadcrumb('createProject', 'projects');
        } else if (routeName === 'client.projects.edit') {
            addContextualBreadcrumb('editProject', 'projects');
        } else {
            addContextualBreadcrumb('allProjects', 'projects');
        }
        sessionStorage.setItem('previousRoute', routeName);
    } else if (routeName?.startsWith('client.carts')) {
        addContextualBreadcrumb('cart');
        sessionStorage.setItem('previousRoute', routeName);
    } else if (routeName?.startsWith('client.profile')) {
        addContextualBreadcrumb('profile');
        sessionStorage.setItem('previousRoute', routeName);
        if (routeName === 'client.profile.show') {
            breadcrumbs.push($t('Settings'));
        }
    } else if (routeName === 'client.bug-report') {
        addContextualBreadcrumb('bugReport');
        sessionStorage.setItem('previousRoute', routeName);
    } else if (routeName?.startsWith('client.checkout')) {
        if (routeName === 'client.checkout.success') {
            addContextualBreadcrumb('orderCreated', 'linkBuilding');
        } else {
            addContextualBreadcrumb('checkout', 'linkBuilding');
        }
        sessionStorage.setItem('previousRoute', routeName);
    } else if (routeName === 'client.place-order.index') {
        breadcrumbs.push($t(pageTitles('linkBuilding')));
        breadcrumbs.push($t(pageTitles('checkout')));
        breadcrumbs.push($t(pageTitles('placeOrder')));
        sessionStorage.setItem('previousRoute', routeName);
    }

    return breadcrumbs;
});
</script>

<template>
    <BaseDashboardBreadcrumb :breadcrumb-items="breadcrumbItems" />
</template>
